<template>
  <div class="f-right">
    <Timer
      ref="timer"
      :limitTime="limitTime"
      :reportId="reportId"
      :initValue="seconds"
      :count="answerCount"
      :storeKey="storeKey"
      :allowPause="allowPause"
      @update="val => (seconds = val)"
      @submit="submit(true)"
    ></Timer>
    <div class="topic-nav clearfix">
      <a class="prev" :class="{ disabled: index == 1 }" @click="navPrev">
        上一题
      </a>
      <a class="next" :class="{ disabled: index == total }" @click="navNext">
        下一题
      </a>
    </div>
    <AnswerSheet
      :index="index"
      :total="total"
      :scantron="scantron"
      :hasSection="hasSection"
      :hasNotSupport="hasNotSupport"
      @goTo="index => goTo(index)"
    ></AnswerSheet>
    <div class="submit" @click="submit()">交卷</div>
  </div>
</template>
<script>
import Timer from "@/components/ques/Timer.vue";
import AnswerSheet from "@/components/ques/AnswerSheet.vue";
export default {
  name: "ExamDoRight",
  components: {
    Timer,
    AnswerSheet,
  },
  props: {
    limitTime: {
      type: Number,
      default: 0,
    },
    reportId: {},
    scantron: {
      type: Object,
      default: () => {
        return {};
      },
    },
    hasSection: {
      type: Boolean,
      default: false,
    },
    answer: {
      type: Object,
      default: () => {
        return {};
      },
    },
    current: {
      type: Object,
      default: () => {
        return {};
      },
    },
    storeKey: {
      type: String,
      default: "exam-seconds",
    },
    allowPause: {
      type: Boolean,
      default: true,
    },
    hasNotSupport: {
      type: Boolean,
      default: true,
    },
    shotAnswerEditable: {
      type: Boolean,
      default: false,
    },
    submitTopicFunc: {
      type: Function,
    },
  },
  data() {
    return {
      index: 0,
      seconds: 0,
      hasInit: false,
    };
  },
  computed: {
    total() {
      return this.scantronQuestions.length;
    },
    answerCount() {
      return this.scantronQuestions.filter(q => q.status == 1 || q.status == 2)
        .length;
    },
    scantronQuestions() {
      if (!this.scantron.list) {
        return [];
      }
      if (this.hasSection) {
        let list = [];
        this.scantron.list.forEach(t => {
          t.child.forEach(ques => {
            list.push(ques);
          });
        });
        return list;
      } else {
        return this.scantron.list;
      }
    },
  },
  watch: {
    current() {
      if (this.hasInit) {
        return;
      }
      this.seconds =
        (this.$storage().get(this.storeKey) || {})[this.reportId] ||
        this.current.answer_time;
      this.$nextTick(() => {
        this.$refs.timer.start();
      });
      this.hasInit = true;
    },
  },
  methods: {
    init(index) {
      this.index = index;
      this.getTopic();
    },
    getTopic() {
      this.$emit("getTopic", { reportId: this.reportId, index: this.index });
    },
    async submitTopic() {
      if (!this.shotAnswerEditable && this.current.ques_type == 5) {
        return;
      }
      let answer = "";
      if (this.current.ques_type == 1 || this.current.ques_type == 2) {
        answer = this.answer[this.current.question_id];
      } else if (this.current.ques_type == 3 || this.current.ques_type == 4) {
        answer = this.answer[this.current.question_id].join(",");
      } else if (this.current.ques_type == 5) {
        if (this.shotAnswerEditable) {
          answer = this.answer[this.current.question_id];
        }
      }
      let params = {
        report_id: this.reportId,
        question_id: this.current.question_id,
        user_answer: answer || "",
        answer_time: this.seconds,
        question: this.current,
      };
      if (this.submitTopicFunc) {
        await this.submitTopicFunc(params);
      } else {
        this.$emit("submitTopic", params);
      }
    },
    async navPrev() {
      if (this.index == 1) {
        return;
      }
      this.index--;
      await this.submitTopic();
      this.getTopic();
    },
    async navNext() {
      if (this.index == this.total) {
        return;
      }
      this.index++;
      await this.submitTopic();
      this.getTopic();
    },
    async goTo(index) {
      this.index = index;
      await this.submitTopic();
      this.getTopic();
    },
    async submit(autoSubmit = false) {
      await this.submitTopic();
      if (!autoSubmit) {
        this.$refs.timer.stop();
        let count = this.scantronQuestions.filter(q => q.status == 3).length;
        if (count > 0) {
          await this.$promiseConfirm(
            "您还有" + count + "道题未做，确定要提交吗？",
            {
              type: "warning",
              customClass: "dialog-exam dialog-exam-progress",
              confirmButtonText: "确定交卷",
              cancelButtonText: "继续答题",
              callback: () => {
                this.$refs.timer.continue();
              },
            },
          );
        } else {
          await this.$promiseConfirm("确定要提交吗？", {
            type: "warning",
            customClass: "dialog-exam dialog-exam-end",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            callback: () => {
              this.$refs.timer.continue();
            },
          });
        }
      }

      let store = this.$storage().get(this.storeKey) || {};
      delete store[this.id];
      this.$storage().set(this.storeKey, store);

      this.$emit("submit", {
        id: this.reportId,
        answer_time: this.seconds,
        autoSubmit,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.submit {
  background-color: $primary-color;
  color: white;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  padding: 12px 0;
  cursor: pointer;
}
.topic-nav {
  display: flex;
  a {
    width: 120px;
    height: 36px;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  .prev {
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    color: rgba(51, 51, 51, 1);
    margin-right: 10px;

    &:not(.disabled):hover {
      border-color: $primary-color;
      color: $primary-color;
    }
  }
  .next {
    background: $primary-color;
    color: white;

    &:not(.disabled):hover {
      background: $primary-color-hover;
    }
  }
}
</style>
<style lang="scss">
.dialog-exam {
  width: 480px;
  box-sizing: border-box;
  padding: 35px 20px 20px 24px;
  .el-message-box__header {
    display: none;
  }
  .el-message-box__content {
    padding: 0;
    margin-bottom: 70px;
    font-size: 16px;
    color: rgba(52, 52, 52, 1);
    line-height: 1;
  }
  .el-message-box__btns {
    padding: 0;
    overflow: hidden;
  }
  .el-button {
    width: 98px;
    height: 36px;
    background: rgba(252, 86, 36, 0);
    border: 1px solid rgba(204, 204, 204, 1);
    border-radius: 3px;
    padding: 0;
    font-size: 14px;
    color: rgba(52, 52, 52, 1);

    &:nth-child(2) {
      margin-left: 14px;
    }

    &:hover {
      border-color: $primary-color;
      color: $primary-color;
    }
  }
}
.dialog-exam-progress {
  .el-button {
    float: right;

    &:nth-child(1) {
      margin-left: 14px;
      background-color: $primary-color !important;
      border-color: $primary-color !important;
      color: white;

      &:hover {
        background-color: $primary-color-hover !important;
        border-color: $primary-color-hover !important;
        color: white !important;
      }
    }
  }
}
.dialog-exam-end {
  .el-button {
    &:nth-child(2) {
      margin-left: 14px;
      background-color: $primary-color !important;
      border-color: $primary-color !important;
      color: white;

      &:hover {
        background-color: $primary-color-hover !important;
        border-color: $primary-color-hover !important;
        color: white !important;
      }
    }
  }
}
</style>
